var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyResultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 200,
    viewBox: "0 0 320 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M302.671 42.5459L188.721 155.812C185.392 159.129 180.861 160.992 176.148 161H24.8725C19.9934 160.969 16 156.968 16 152.118C16 149.799 16.9173 147.567 18.5463 145.908L124.905 40.5022C128.227 37.083 132.774 35.1022 137.558 35H299.587C302.007 35.0079 304 36.9965 304 39.4017C304 40.5808 303.518 41.7205 302.671 42.5459Z",
    fill: "#E8EFF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 57.0909,
    width: 81,
    height: 97,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 61H261V153H185V61Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.061,
    y: 72.1818,
    width: 60.8788,
    height: 73.4545,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.885 49.9938C210.847 44.8849 215.681 41 221.5 41C227.319 41 232.153 44.8849 233.116 49.9938H244.235C246.959 49.9938 249.167 52.202 249.167 54.9259V63.6363H193.833V54.9259C193.833 52.202 196.041 49.9938 198.765 49.9938H209.885Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.885 49.9938C210.847 44.8849 215.681 41 221.5 41C227.319 41 232.153 44.8849 233.116 49.9938H244.235C246.959 49.9938 249.167 52.202 249.167 54.9259V63.6363H193.833V54.9259C193.833 52.202 196.041 49.9938 198.765 49.9938H209.885Z",
    fill: "#8664FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.885 49.9938V51.9938H211.543L211.85 50.3641L209.885 49.9938ZM233.116 49.9938L231.15 50.3641L231.457 51.9938H233.116V49.9938ZM249.167 63.6363V65.6363H251.167V63.6363H249.167ZM193.833 63.6363H191.833V65.6363H193.833V63.6363ZM211.85 50.3641C212.617 46.2943 216.544 43 221.5 43V39C214.818 39 209.077 43.4756 207.919 49.6236L211.85 50.3641ZM221.5 43C226.456 43 230.384 46.2943 231.15 50.3641L235.081 49.6236C233.923 43.4756 228.182 39 221.5 39V43ZM233.116 51.9938H244.235V47.9938H233.116V51.9938ZM244.235 51.9938C245.854 51.9938 247.167 53.3066 247.167 54.9259H251.167C251.167 51.0974 248.063 47.9938 244.235 47.9938V51.9938ZM247.167 54.9259V63.6363H251.167V54.9259H247.167ZM249.167 61.6363H193.833V65.6363H249.167V61.6363ZM195.833 63.6363V54.9259H191.833V63.6363H195.833ZM195.833 54.9259C195.833 53.3066 197.146 51.9938 198.765 51.9938V47.9938C194.937 47.9938 191.833 51.0974 191.833 54.9259H195.833ZM198.765 51.9938H209.885V47.9938H198.765V51.9938Z",
    fill: "#220C4A",
    mask: "url(#path-5-inside-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53 52.3181C225.53 54.544 223.726 56.3485 221.5 56.3485C219.274 56.3485 217.47 54.544 217.47 52.3181C217.47 50.0923 219.274 48.2878 221.5 48.2878C223.726 48.2878 225.53 50.0923 225.53 52.3181Z",
    fill: "#FFD65A",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227 87C227.724 89.8377 231.478 92 236 92C240.522 92 244.276 89.8377 245 87H242.872C242.61 87.5188 242.129 88.0625 241.354 88.5715C240.073 89.4138 238.186 90 236 90C233.814 90 231.927 89.4138 230.646 88.5715C229.871 88.0625 229.39 87.5188 229.128 87H227Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217 100C217.443 102.27 219.737 104 222.5 104C225.263 104 227.557 102.27 228 100H225.915C225.5 101.036 224.303 102 222.5 102C220.697 102 219.5 101.036 219.085 100H217Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199 87C199.724 89.8377 203.478 92 208 92C212.522 92 216.276 89.8377 217 87H214.872C214.61 87.5188 214.129 88.0625 213.354 88.5715C212.073 89.4138 210.186 90 208 90C205.814 90 203.927 89.4138 202.646 88.5715C201.871 88.0625 201.39 87.5188 201.128 87H199Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.827 135.857H222.214V142.102H231.582V156.5H237.827V140.888H237.827V135.857Z",
    fill: "#2CE27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.214 135.857V134.857H221.214V135.857H222.214ZM237.827 135.857H238.827V134.857H237.827V135.857ZM222.214 142.102H221.214V143.102H222.214V142.102ZM231.582 142.102H232.582V141.102H231.582V142.102ZM231.582 156.5H230.582V157.5H231.582V156.5ZM237.827 156.5V157.5H238.827V156.5H237.827ZM237.827 140.888H238.827V139.888H237.827V140.888ZM237.827 140.888H236.827V141.888H237.827V140.888ZM222.214 136.857H237.827V134.857H222.214V136.857ZM223.214 142.102V135.857H221.214V142.102H223.214ZM231.582 141.102H222.214V143.102H231.582V141.102ZM232.582 156.5V142.102H230.582V156.5H232.582ZM237.827 155.5H231.582V157.5H237.827V155.5ZM236.827 140.888V156.5H238.827V140.888H236.827ZM237.827 141.888H237.827V139.888H237.827V141.888ZM236.827 135.857V140.888H238.827V135.857H236.827Z",
    fill: "#220C4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.302 132H224.698C225.306 132 225.773 132.538 225.688 133.14L221.453 163.14C221.383 163.633 220.961 164 220.463 164H193.537C193.039 164 192.617 163.633 192.547 163.14L188.312 133.14C188.227 132.538 188.694 132 189.302 132Z",
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.718 128.5C215.305 127.797 217 126.5 216 124.5C215.319 123.138 214.663 122.459 214.131 120.419C213.631 118.5 214.653 117.405 215.631 116",
    stroke: "#8664FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.5 128.5C208 127.5 209.1 126.1 209.5 124.5C210 122.5 207 120 207 117C207 114.6 208.667 112 209.5 110",
    stroke: "#8664FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 144,
    r: 4,
    fill: "#220C4A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 141,
    r: 4,
    fill: "#220C4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.5 143C243 142.5 261.5 141 267.5 127C270.362 120.322 267.5 115 262.5 107",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.17 141C187.67 140.5 178.17 138 175.67 129C173.587 121.5 176.67 117 180.67 109",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 164,
    width: 34,
    height: 4,
    rx: 2,
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 35,
    width: 288,
    height: 126
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.671 42.5459L188.721 155.812C185.392 159.129 180.861 160.992 176.148 161H24.8725C19.9934 160.969 16 156.968 16 152.118C16 149.799 16.9173 147.567 18.5463 145.908L124.905 40.5022C128.227 37.083 132.774 35.1022 137.558 35H299.587C302.007 35.0079 304 36.9965 304 39.4017C304 40.5808 303.518 41.7205 302.671 42.5459Z",
    fill: "#E8EFF8"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 72,
    width: 12,
    height: 90,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 72,
    width: 12,
    height: 90,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 87,
    width: 74,
    height: 6,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 140,
    width: 74,
    height: 6,
    fill: "white",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 153,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 144,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 135,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 126,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 117,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 108,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 99,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 90,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 81,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 153,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 144,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 135,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 126,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 117,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 108,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 99,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 90,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 81,
    r: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.234 126L138.766 126L135.805 140L122.195 140L119.234 126Z",
    fill: "#8664FF",
    stroke: "#220C4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.021 106.492C131.42 107.133 130.797 111.326 130.797 113.191C143.589 115.429 142.859 106.663 140.896 102C140.335 103.243 140.443 106.1 137.021 106.492Z",
    fill: "#2CE27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.441 112.909C128.93 113.422 129.76 116.973 129.553 118.042C116.483 123.176 117.728 105.85 118.35 109.059C118.972 112.267 123.329 112.267 126.441 112.909Z",
    fill: "#2CE27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.454 126C128.165 125.46 126.516 124.138 127.134 121.548C127.907 118.31 131 117.905 131 114.262C131 111.348 129.196 109.405 128.68 109",
    stroke: "#220C4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyResultIcon);
export default __webpack_public_path__ + "static/media/empty-result-icon.aefcf0c88847634df3275eb3f11112d3.svg";
export { ForwardRef as ReactComponent };